import { render, staticRenderFns } from "./Revisions.vue?vue&type=template&id=4874842e&"
import script from "./Revisions.vue?vue&type=script&lang=js&"
export * from "./Revisions.vue?vue&type=script&lang=js&"
import style0 from "./Revisions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports